module.exports = __webpack_public_path__ + "static/media/alliance-explore-flooring.5046f80d.png";